module.exports = __webpack_public_path__ + "files/d0ee24503b26c07773b1f49fa58a48db.png";